module.exports = __webpack_public_path__ + "img/peoplee.5da44163.svg";